import React from "react";
import PropTypes from "prop-types";
import { Image } from "@sparefoot/react-commons";
import { H1 } from "components/core/Typography";
import SearchBar from "components/search/SearchBar/SearchBar";
import Container from "components/core/Page/Container";
import HeroBg from "assets/images/psp/hero/slp-hero-bg.svg";
import "./HeroSection.scss";

export default function HeroSection({ stateName, heroImages }) {
	const desktopBg = heroImages?.desktop || HeroBg;
	const mobileBg = heroImages?.mobile || HeroBg;

	return (
		<div
			className="slp-hero-container"
			style={{ "--hero-bg-desktop": `url(${desktopBg})` }}
		>
			<Image
				src={mobileBg}
				alt=""
				className="slp-hero__mobile-bg"
				aria-hidden="true"
			/>
			<Container className="slp-hero__overlay">
				<div className="slp-hero-content">
					<H1 className="slp-hero__title">
						Find {stateName} Storage Units
					</H1>
					<SearchBar
						id="slp-hero-search"
						label="Search by city, state, or zip..."
						buttonText="Find Storage"
						theme="plainBlue"
						className="slp-hero__search"
					/>
				</div>
			</Container>
		</div>
	);
}

HeroSection.propTypes = {
	stateName: PropTypes.string.isRequired,
	heroImages: PropTypes.shape({
		desktop: PropTypes.string,
		mobile: PropTypes.string
	})
};
